<template>
  <div>
    <Modal fullscreen v-model="visible" width="90%" title="请选择需要结算的数据" :footer-hide="true" :mask-closable="false" class="my-modal top static">
      <topSearchForm v-if="reportType !== 'extra'" :showSwtich="true" @search="searchAjax" @resetSearch="resetSearch">
        <div class="search-box min ivu-form">
          <div class="input-item">
            <span class="label">保单编号</span>
            <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
          </div>
          <div class="input-item">
            <span class="label">保单状态</span>
            <lzDicSelect :transfer="true" v-model="searchParams.policyStatus" dicType="POLICY_STATUS"> </lzDicSelect>
          </div>
          <div class="input-item">
            <span class="label">签单日期</span>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="searchParams.signDate"
              @on-change="searchParams.signDate = $event"
            ></DatePicker>
          </div>
          <div class="input-item">
            <span class="label">生效日期</span>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="searchParams.effectDate"
              @on-change="searchParams.effectDate = $event"
            ></DatePicker>
          </div>
          <div class="input-item">
            <span class="label">产品名称</span>
            <Select v-model="searchParams.productId" transfer clearable filterable>
              <Option v-for="(item, index) in searchProductList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </div>
          <div class="input-item">
            <span class="label">保司</span>
            <Select v-model="searchParams.companyId" @on-change="companyChange()" transfer clearable filterable>
              <Option v-for="(item, index) in companyList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </div>
          <div class="input-item">
            <span class="label">保单期数</span>
            <Input v-model="searchParams.commissionIndex" placeholder="请输入" clearable />
          </div>
          <div class="input-item">
            <span class="label">犹豫止期</span>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="searchParams.expirationDate"
              @on-change="searchParams.expirationDate = $event"
            ></DatePicker>
          </div>
          <div class="input-item">
            <span class="label">供应商</span>
            <lzDicSelect v-model="searchParams.suppliers" :transfer="true" dicType="SUPPLIERS"> </lzDicSelect>
          </div>
          <div class="input-item">
            <span class="label">产品类型</span>
            <lzDicSelect v-model="searchParams.productType" :transfer="true" dicType="PRODUCT_TYPE2"> </lzDicSelect>
          </div>
          <div class="input-item">
            <span class="label">签单代理人</span>
            <Input v-model="searchParams.signAgent" placeholder="请输入姓名或工号" clearable />
          </div>
          <div class="input-item">
            <span class="label">团队</span>
            <Select v-model="searchParams.groupId" transfer clearable filterable>
              <Option v-for="(bean, i) in groupList" :key="i" :value="bean.id">
                {{ bean.name }}
              </Option>
            </Select>
          </div>
          <div class="input-item">
            <span class="label">佣金项类型</span>
            <Select v-model="searchParams.commissionTypeList" :max-tag-count="1" multiple clearable transfer>
              <Option value="1">基础销售佣金</Option>
              <Option value="11">个人Bonus</Option>
              <Option value="12">管理津贴</Option>
              <Option value="13">推荐奖</Option>
              <Option value="14">辅导奖</Option>
              <Option value="15">育成奖</Option>
            </Select>
          </div>
          <div v-if="reportType === 'basic'" class="input-item">
            <span class="label">特殊标记单</span>
            <Select v-model="searchParams.isReferral" transfer>
              <Option value="999">全部</Option>
              <Option value="1">是</Option>
              <Option value="0">否</Option>
            </Select>
          </div>
           <div v-if="reportType === 'basic'" class="input-item">
            <span class="label">是否观察中</span>
            <Select v-model="searchParams.isObservation" transfer clearable>
              <Option value="1">是</Option>
              <Option value="0">否</Option>
            </Select>
          </div>
        </div>
      </topSearchForm>
      <div v-else class="search-box min ivu-form">
        <div class="input-item">
          <span class="label">保单编号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">IFA</span>
          <Select v-model="searchParams.owerId" clearable filterable transfer>
            <Option v-for="item in ifaList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">佣金项类型</span>
          <Select v-model="searchParams.commissionTypeList" :max-tag-count="1" multiple clearable transfer>
            <Option value="1">周边收支</Option>
            <Option value="2">佣金调整</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">收支类型</span>
          <Select v-model="searchParams.incomeType" clearable transfer>
            <Option value="1">收入</Option>
            <Option value="2">支出</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>
      <div class="toolbox clearfix">
        <div class="statistics fl">
          <div class="fl">
            <Checkbox v-model="isAll" :disabled="!tableData || (tableData && !tableData.length)" @on-change="selectAll">全部</Checkbox>
          </div>
        </div>
      </div>
      <div class="table-box setTable">
        <loading :isShow="listLoading" />
        <Table
          :columns="reportType === 'extra' ? extraColumns : columns"
          :data="tableData"
          @on-select="onSelect"
          @on-select-cancel="onSelectCancel"
          @on-select-all="onSelect"
          @on-select-all-cancel="onSelectAllCancel"
        >
          <template slot-scope="{ row }" slot="commissionType">
            <span>{{ commissionTypeMap[row.commissionType] }}</span>
            <Tag v-if="(row.commissionType == 15 || row.commissionType == 16) && row.isObservation === '1'" class="commission-tag" color="warning">观察</Tag>
          </template>
          <template slot-scope="{ row }" slot="reportName">
            <span class="report-name" @click="toDetail(row)">{{ row.reportName }}</span>
          </template>
        </Table>
        <Page
          :total="total"
          :current="pageNum"
          :page-size="pageSize"
          show-total
          @on-change="getList"
          :page-size-opts="[10, 20, 30, 50, 100]"
          style="text-align: center"
        />
      </div>

      <div class="ivu-modal-footer">
        <Button type="primary" @click="submit">加入结算</Button>
        <Button type="text" @click="visible = false">取消</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import topSearchForm from '@/components/commons/topSearchForm';
import lzDicSelect from '@/components/commons/lzDicSelect';
import { common, pageTool } from '@/api/mixins';
import { config } from './selPolicyModal.config.js';
export default {
  mixins: [common, pageTool, config],
  components: {
    lzDicSelect,
    confirmModal,
    topSearchForm
  },
  data() {
    return {
      columns: [],
      groupList: [], //团队
      companyList: [], // 保司列表
      searchProductList: [],
      visible: false,
      loading: false,
      detail: {},
      isAll: false,
      selectArr: [],
      settleId: '',
      reportType: 'basic',
      expand: false,
      selectedIdsObj: {},
      ifaList: [],
      commissionTypeMap: {
        1: '基础销售佣金',
        11: '个人Bonus',
        12: '管理津贴',
        13: '推荐奖',
        14: '辅导奖',
        15: '育成奖',
        16: '育成奖'
      }
    };
  },
  mounted() {
    this.getGroupList();
    this.queryCompanyList();
  },
  methods: {
    getSelectedProductIds() {
      const selectedIdsObj = {};
      this.selectArr.forEach(p => {
        selectedIdsObj[p.id] = 1;
      });
      this.selectedIdsObj = selectedIdsObj;
    },
    listCallback(res) {
      this.getSelectedProductIds();
      if (res.data && res.data.length) {
        // this.isAll = true;
      } else {
        this.isAll = false;
      }
      res.data.forEach(item => {
        if (this.selectedIdsObj[item.id]) {
          item._checked = true;
        }
        if (this.isAll) {
          item._checked = true;
        }
      });
    },
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._checked = status;
      });
      this._searchAllParams = JSON.parse(JSON.stringify(this.searchParams));
      this.tableData = tableData;
      this.selectArr = tableData.filter(item => item._checked);
    },
    // 列表选中
    onSelect(selectArr) {
      selectArr.forEach(item => {
        this.selectPush(item);
      });
    },
    // 列表单个取消选中
    onSelectCancel(selectArr, row) {
      this.selectDel(row);
      this.isAll = false;
    },
    // 列表全选取消
    onSelectAllCancel() {
      this.tableData.forEach(item => {
        this.selectDel(item);
      });
      this.isAll = false;
    },
    // 添加选择数据
    selectPush(data) {
      const has = this.selectArr.some(item => item.id == data.id);
      if (!has) {
        this.selectArr.push(data);
        if (this.selectArr.length == this.total) {
          this.isAll = true;
        } else {
          this.isAll = false;
        }
      }
    },
    // 去掉选择数据
    selectDel(data) {
      this.selectArr.forEach((item, idx) => {
        if (item.id == data.id) {
          this.selectArr.splice(idx, 1);
        }
      });
    },
    open({ id }, reportType = 'basic') {
      this.getColumns();
      this.isAll = false;
      this.searchParams = {
        isReferral: '999'
      };
      this.tableData = [];
      this.selectArr = [];
      this.settleId = id;
      this.reportType = reportType;
      this.apiPrefix = reportType === 'extra' ? '/buz/ifaExtraSettlementReport' : '/buz/ifaSettlementReport';
      if (reportType === 'extra') {
        this.getIfaList();
      }
      this.visible = true;
      this.initListAjax(this.apiPrefix + '/queryWaitSettlePage');
    },
    // 选择保司，查询产品
    companyChange() {
      if (!this.searchParams.companyId) {
        this.$set(this.searchParams, 'productId', '');
      }
      if (!this.searchParams.companyId) return;
      this.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: { companyId: this.searchParams.companyId }
      }).then(res => {
        this.searchProductList = res.data;
      });
    },
    // 获取团队列表
    getGroupList() {
      this.$http({
        url: '/buz/groupBase/read/list',
        type: 'POST',
        data: {
          pageSize: 999,
          pageNo: 1
        }
      }).then(res => {
        this.groupList = res.data;
      });
    },
    // 查询所有保司
    queryCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        this.companyList = res.data;
      });
    },
    getIfaList() {
      this.$http({
        url: '/buz/userBase/list',
        type: 'POST',
        data: { selectSub: 1 }
      }).then(res => {
        this.ifaList = res.data.filter(i => i.ifaType != 2);
      });
    },

    setListParams(params) {
      if (params.commissionTypeList && params.commissionTypeList.includes('15')) {
        params.commissionTypeList.push('16');
      }
      if (this.reportType === 'extra') {
        params.extraSettleId = this.settleId;
      } else {
        params.settleId = this.settleId;
      }
      // 特殊标记单
      if (params.isReferral == 999 || this.reportType === 'extra') {
        delete params.isReferral;
      }

      //  签单日期
      if (params.signDate && params.signDate[0]) {
        params.signDateStart = params.signDate[0];
        params.signDateEnd = params.signDate[1];
      }
      delete params.signDate;

      // 冷静期截止日
      if (params.expirationDate && params.expirationDate[0]) {
        params.expirationDateStart = params.expirationDate[0];
        params.expirationDateEnd = params.expirationDate[1];
      }
      delete params.expirationDate;

      // 生效日期
      if (params.effectDate && params.effectDate[0]) {
        params.effectDateStart = params.effectDate[0];
        params.effectDateEnd = params.effectDate[1];
      }
      delete params.effectDate;
    },
    submit() {
      if (!this.selectArr.length && !this.isAll) {
        this.$notice.msg('请选择要加入结算的保单');
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$http({
        url: this.apiPrefix + '/addSettlement',
        type: 'POST',
        forced: true,
        data: {
          ids: this.selectArr.map(item => item.id),
          isAll: this.isAll ? '1' : '0',
          ...(this.reportType === 'extra' ? { extraSettleId: this.settleId } : { settleId: this.settleId }),
          ...params
        }
      })
        .then(res => {
          console.log('加入结算失败', res);
          if (res.httpCode != 1) {
            this.$refs.confirmModal
              .open({
                title: '提示',
                content: res.msg
              })
              .then(() => {
                this.selectArr = [];
                this.getList();
                this.isAll = false;
                this.$emit('close');
                this.visible = false;
              })
              .catch(() => {
                this.selectArr = [];
                this.getList();
                this.isAll = false;
                this.$emit('close');
              });
            return;
          }
          this.$notice.success('加入结算成功');
          this.$emit('close');
          this.visible = false;
        })
        .catch(err => {
          console.log('加入结算失败', err);
          // this.isAll = false;

          this.selectArr = [];
          this.getList();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.commission-tag {
  height: 18px;
  line-height: 18px;
  padding: 0 5px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  z-index: 100;
  transform: translateX(10px);
}

/deep/ .tip-icon {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #ccc;
  color: #ccc;
  display: inline-block;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  top: 50%;
}
/deep/.ivu-modal {
  top: 0 !important;
}
/deep/.ivu-modal-body {
  padding-top: 20px !important;
}
/deep/.text-box {
  padding: 0 !important;
}
.ivu-modal-footer {
  position: relative !important;
}
/deep/.showSwtich .ivu-form {
  height: 40px !important;
}
/deep/.isopen .ivu-form {
  height: auto !important;
}
</style>
